<template src="./obiettivi.html"></template>

<script>
import { get_obiettivi, set_obiettivo } from "@/api/api.obiettivi.js";

export default {
  data: () => ({
    progresso: {
      percentuale: [],
      fatturato: "0",
      massimo: "0",
      color: [],
      backgroundColor: [],
    },
    customValue: 0,

    //elenco di tutti gli agenti
    elencoAgenti: [],
    headersTabella: [
      {
        text: "Agente",
        value: "NomeAgente",
        style: "max-width: 150px !important",
        class: "ma-0 pa-0",
      },
      {
        text: "",
        value: "Obiettivo",
        class: "ma-0 pa-0",
        style: "min-width:50% !important",
        sortable: false,
      },
      {
        text: "",
        value: "",
        style: "min-width: 100px !important",
        class: "ma-0 pa-0",
        sortable: false,
      },
      { text: "", value: "", class: "ma-0 pa-0", sortable: false },
      /* { text: "", value: "", class: "ma-0 pa-0", sortable: false }, */
    ],
    itemsPage: 99,

    dialogModifica: false,
    obiettivoSel: {},
    nuovoObiettivo: "",
    vecchioObiettivo: "",

    //password modifica obiettivo
    passwordCorretta: false,
    password: "",
    showPass: false,
    rules: { required: (value) => !!value || "Obbligatorio" },

    //filtro anni
    startYear: 2022,
    anni: [],
    annoSel: "",

    expanded: [],
    singleExpand: false,
    rowClickedData: [],
    selectedRow: {},
  }),

  methods: {
    async caricaDati() {
      if (this.annoSel == null || this.annoSel == "") {
        this.$toast.error("Nessun anno selezionato");
        return;
      }

      let codice = this.userSwitch.Codice;
      if (
        this.role == "Admin" &&
        (codice == undefined || codice == null || codice == "")
      ) {
        codice = 0;
      }

      if (codice == undefined || codice == null || codice == "") {
        if (this.role.toLower != "admin") {
          codice = this.$store.getters["user/getCodice"];
        } else {
          this.$toast.warning("Selezionare un agente");
          return;
        }
      }
      this.caricaObiettivi(codice);
    },

    async caricaObiettivi(codAgente) {
      let res = await get_obiettivi(codAgente, this.annoSel);
      this.elencoAgenti = res.data;
      if (this.elencoAgenti.length == 1) this.elencoAgenti[0].expanded = true;
    },

    refresh() {
      this.progresso = {
        percentuale: [],
        fatturato: "0",
        massimo: "0",
        color: [],
        backgroundColor: [],
      };
      this.caricaDati();
    },

    getMessaggio() {
      if (this.progresso.mesi == null || this.progresso.mesi == undefined)
        return "";
      let msg = "Obiettivo mensile raggiunto!";
      this.progresso.mesi.forEach((el) => {
        if (el.popup) {
          msg =
            "Mancano " +
            el.popupValue +
            " € al raggiungimento dell'obiettivo mensile";
        }
      });

      return msg;
    },

    selectObiettivo(props) {
      this.selectedRow = props;
      //props.expanded = !props.expanded;
    },

    rowClicked(props) {
      this.rowClickedData = props;
      this.expanded = [];
      props.expanded = !props.expanded;
      if (!props.expanded) {
        this.ResetExpanded();
        return;
      }
      this.expanded.push(props);
    },

    ResetExpanded() {
      this.elencoAgenti.forEach((el) => {
        el.expanded = false;
      });
    },

    async apriModificaObiettivo(props) {
      this.passwordCorretta = false;

      this.vecchioObiettivo = props.Obiettivo.MassimoInt;
      this.obiettivoSel = props;

      this.dialogModifica = true;
      await this.$functions.delay(200);

      this.$refs.txtPassword.focus();
    },

    chiudiDialogObiettivo() {
      this.dialogModifica = false;
    },

    async modificaObiettivo() {
      let confirm = await this.$root.$confirm(
        "Cambio obiettivo",
        "Vuoi cambiare l'obiettivo annuale per l'agente " +
        this.obiettivoSel.NomeAgente +
        " ?"
      );
      if (!confirm) return;

      if (this.nuovoObiettivo == null || this.nuovoObiettivo == "") return;

      let par = {
        CodAgente: this.obiettivoSel.CodAgente,
        Obiettivo: this.nuovoObiettivo,
        Nome: this.obiettivoSel.NomeAgente,
        Anno: this.annoSel,
      };
      let res = await set_obiettivo(par);
      if (res.data != "OK") {
        this.$toast.error(
          "Errore. Impossibile modificare l'obiettivo: " + res.data
        );
        return;
      }
      this.dialogModifica = false;
      this.nuovoObiettivo = "";
      this.caricaDati();
    },

    async checkPassword() {
      if (this.password == null || this.password == "") return;
      else if (this.password == "Zena") {
        this.passwordCorretta = true;
        this.password = "";
        await this.$functions.delay(100);
        this.$refs.txtNuovoOb.focus();
      } else this.$toast.error("Password non corretta");
    },
  },

  async mounted() {
    this.annoSel = this.$i2kFunctions.getYear();
    for (let i = this.startYear; i <= this.annoSel; i++) this.anni.push(i);

    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);
    this.progresso.percentuale = [];
    this.caricaDati();
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    role: function () {
      return this.$store.getters["user/getRole"];
    },

    months: function () {
      return this.$i2kFunctions.getShortMonths();
    },
  },

  watch: {
    userSwitch() {
      if (this.userSwitch != null && this.userSwitch != undefined)
        this.refresh();
    },
  },
};
</script>

<style scoped>
#popupMese {
  color: black;
  background-color: #a5d6a7;
  border-radius: 7px;
}
</style>